import styled from 'styled-components';

export const StarWrapper = styled.div`
    align-items: center;
    display:flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    margin: ${ props => ('disabled' in props) ? '0px 5px' : '0px 10px' };
    user-select: none;
`;
StarWrapper.displayName = 'StarWrapper';
